import React from 'react';
import { Link } from 'react-router-dom';

const PublisherLink = () => {
  return (
    <div>
      <Link to="/resources">
        Visit our Favorite Publishers!
      </Link>
    </div>
  );
};

export default PublisherLink; 